<template>
  <TrfModal
    v-if="isAtivo"
    idModal="modal-concluir-tarefa"
    :titulo="titulo"
    btnSaveName="Confirmar"
    :isBtnLoading="isLoading"
    @save="handleConfirmar"
    @close="handleFechar"
    v-e2e="'modal-concluir-tarefa'"
  >
    <p>Deseja realmente concluir esta tarefa?</p>
  </TrfModal>
</template>

<script>
import { defineAsyncComponent } from 'vue';

export default {
  name: 'TrfModalConcluirTarefa',
  components: {
    TrfModal: defineAsyncComponent(() => import('../index.vue'))
  },
  props: {
    isAtivo: {
      type: Boolean,
      required: true
    },
    tarefa: {
      type: Object,
      required: true
    },
    titulo: {
      type: String,
      default: 'Concluir tarefa'
    }
  },
  emits: ['confirmar', 'fechar'],
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    handleConfirmar() {
      this.isLoading = true;
      this.$emit('confirmar', this.tarefa);
    },
    handleFechar() {
      this.isLoading = false;
      this.$emit('fechar');
    }
  },
  watch: {
    isAtivo(novoValor) {
      if (!novoValor) {
        this.isLoading = false;
      }
    }
  }
};
</script>
